import React from 'react';
import { Typography } from '@material-ui/core';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

/** Render user text safely; HTML-like input stays text. */
const Text = ({ text, content, title, align = 'left', fontSize = 14, fontWeight = 400, color, padding = 0 }) => {
  const t = useLocalizedMessage();
  return (
    <Typography component="div" style={{ textAlign: align, fontSize, fontWeight, color, padding, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
      {text ?? content ?? title ?? t('searchInterface.preview.textPlaceholder')}
    </Typography>
  );
};

export default Text;
